"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AddCompensationCycleOwnerResponse () {
        return AddCompensationCycleOwnerResponse;
    },
    get BudgetReviewApprovalEntry () {
        return BudgetReviewApprovalEntry;
    },
    get BudgetReviewEmployeeCompensationResult () {
        return BudgetReviewEmployeeCompensationResult;
    },
    get BudgetReviewsResponse () {
        return BudgetReviewsResponse;
    },
    get CompensationSettingsResponse () {
        return CompensationSettingsResponse;
    },
    get DismissSalaryVisConflictBannerResponse () {
        return DismissSalaryVisConflictBannerResponse;
    },
    get GetCompanySalaryCustomFieldData () {
        return GetCompanySalaryCustomFieldData;
    },
    get GetCompanySalaryCustomFieldId () {
        return GetCompanySalaryCustomFieldId;
    },
    get GetCycleUsersWithoutCompensationDataResponse () {
        return GetCycleUsersWithoutCompensationDataResponse;
    },
    get GetSelectionManagersResponse () {
        return GetSelectionManagersResponse;
    },
    get GetUserHasDismissedSalaryBannerData () {
        return GetUserHasDismissedSalaryBannerData;
    },
    get GetUsersWithoutCompensationDataResponse () {
        return GetUsersWithoutCompensationDataResponse;
    },
    get IndividualBudgetGroup () {
        return IndividualBudgetGroup;
    },
    get RemoveCompensationCycleOwnerResponse () {
        return RemoveCompensationCycleOwnerResponse;
    },
    get UpdateCompensationCycleOwnersResponse () {
        return UpdateCompensationCycleOwnersResponse;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _response = require("./cycles/response");
const CompensationSettingsResponse = _zod.z.object({
    cycleOwners: _zod.z.array(_zod.z.object({
        _id: _zod.z.string(),
        name: _zod.z.string(),
        role: _zod.z.enum([
            "Billing Admin",
            "Admin",
            "Basic Admin"
        ]),
        isAdmin: _zod.z.boolean()
    })),
    admins: _zod.z.array(_zod.z.object({
        _id: _zod.z.string(),
        name: _zod.z.string()
    })),
    billingAdmins: _zod.z.array(_zod.z.object({
        _id: _zod.z.string(),
        name: _zod.z.string()
    })),
    basicAdmins: _zod.z.array(_zod.z.object({
        _id: _zod.z.string(),
        name: _zod.z.string()
    })),
    totalSalary: _zod.z.number(),
    totalSalaryUpdatedAt: _zod.z.string().nullable(),
    integrationType: _zod.z.string().nullable()
});
const UpdateCompensationCycleOwnersResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const AddCompensationCycleOwnerResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const RemoveCompensationCycleOwnerResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const GetSelectionManagersResponse = _zod.z.object({
    managers: _zod.z.array(_zod.z.object({
        _id: _zod.z.string(),
        name: _zod.z.string(),
        jobTitle: _zod.z.string().nullable(),
        directReportCount: _zod.z.number(),
        totalCompensation: _zod.z.number(),
        managerId: _zod.z.string().nullable(),
        managerName: _zod.z.string().nullable()
    })),
    totalCount: _zod.z.number()
});
const GetUsersWithoutCompensationDataResponse = _zod.z.object({
    excludeUsersWithoutManager: _zod.z.array(_zod.z.object({
        _id: _utilsisomorphic.transformObjectId,
        name: _zod.z.string()
    })),
    excludeUsersWithoutSalary: _zod.z.array(_zod.z.object({
        _id: _utilsisomorphic.transformObjectId,
        name: _zod.z.string()
    })),
    uniqueExcludedUsers: _zod.z.array(_zod.z.object({
        _id: _zod.z.string(),
        name: _zod.z.string()
    })),
    totalCount: _zod.z.number()
});
const GetCompanySalaryCustomFieldData = _zod.z.object({
    salaryCustomField: _zod.z.object({
        visibility: _zod.z.array(_zod.z.string())
    })
});
const GetUserHasDismissedSalaryBannerData = _zod.z.object({
    userHasDismissedBanner: _zod.z.boolean().optional(),
    userHasDismissedBannerAt: _zod.z.date().optional().nullable()
});
const DismissSalaryVisConflictBannerResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const BudgetReviewApprovalEntry = _zod.z.object({
    approverId: _utilsisomorphic.transformObjectId,
    approverName: _zod.z.string(),
    sequence: _zod.z.number(),
    status: _zod.z.enum([
        "pending",
        "approved",
        "submitted"
    ]),
    decidedAt: _zod.z.coerce.date().nullable(),
    notes: _zod.z.string().nullable(),
    amountAtApproval: _zod.z.number().nullable(),
    updatedAt: _zod.z.coerce.date().optional(),
    proposedIncreaseAmount: _zod.z.number().optional().nullable(),
    proposedIncreasePercent: _zod.z.number().optional().nullable(),
    proposedSalary: _zod.z.number().optional().nullable()
});
const BudgetReviewEmployeeCompensationResult = _zod.z.object({
    id: _utilsisomorphic.transformObjectId,
    companyId: _utilsisomorphic.transformObjectId,
    compensationCycle: _utilsisomorphic.transformObjectId,
    employeeId: _utilsisomorphic.transformObjectId,
    createdAt: _zod.z.coerce.date(),
    managerId: _utilsisomorphic.transformObjectId,
    overrideManagerId: _utilsisomorphic.transformObjectId.nullable(),
    currentSalary: _zod.z.number(),
    currentSalaryCurrency: _zod.z.string(),
    proposedIncreaseAmount: _zod.z.number().min(0).nullable(),
    proposedIncreasePercent: _zod.z.number().min(0).nullable(),
    proposedSalary: _zod.z.number().min(0).nullable(),
    status: _models.EmployeeCompensationModel.shape.status,
    currentApproverId: _utilsisomorphic.transformObjectId.nullable(),
    approvals: _zod.z.array(BudgetReviewApprovalEntry),
    updatedAt: _zod.z.coerce.date().optional(),
    managerName: _zod.z.string(),
    overrideManagerName: _zod.z.string().nullable(),
    employeeName: _zod.z.string(),
    myDecisionNotes: _zod.z.string().nullable().optional()
});
const IndividualBudgetGroup = _zod.z.object({
    managerId: _zod.z.string(),
    managerName: _zod.z.string(),
    managerJobTitle: _zod.z.string(),
    managerDirectReportCount: _zod.z.number().int().nonnegative(),
    overrideManagerId: _zod.z.string().nullable(),
    overrideManagerName: _zod.z.string().nullable(),
    status: _models.EmployeeCompensationModel.shape.status,
    results: _zod.z.array(BudgetReviewEmployeeCompensationResult),
    compensationCycle: _utilsisomorphic.transformObjectId
});
const BudgetReviewsResponse = _zod.z.object({
    compensationCycleData: _response.CompensationCycleResponse.nullable(),
    individualBudgets: _zod.z.record(_zod.z.string(), IndividualBudgetGroup)
});
const GetCompanySalaryCustomFieldId = _zod.z.object({
    salaryCustomFieldId: _zod.z.string()
});
const GetCycleUsersWithoutCompensationDataResponse = _zod.z.object({
    cycleHasUsersMissingCompData: _zod.z.boolean()
});
